/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import draggable from "vuedraggable";

import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue';


import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunitySuggestBtn from '@/components/Community/CommunitySuggestBtn.component.vue';

import TUploadButton from '@/components/Taktify/TUploadButton.component.vue';
import TSearchField from '@/components/Taktify/TSearchField.component.vue';


import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue';
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue';
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue';
import StatisticsBeamTaktSum from '@/components/ProjectTaktPlan/StatisticsBeamTaktSum.component.vue';


//waggons
import WorkBenchSequenceWaggon from '@/components/WorkBench/WorkBenchSequenceWaggon.component.vue';
import WorkBenchSequenceWaggonAdd from '@/components/WorkBench/WorkBenchSequenceWaggonAdd.component.vue';
import WorkBenchSequenceWaggonTab from '@/components/WorkBench/WorkBenchSequenceWaggonTab.component.vue';
import WorkBenchSequenceWaggonWorkPackage from '@/components/WorkBench/WorkBenchSequenceWaggonWorkPackage.component.vue';
import WorkBenchSequenceWaggonWorkPackageAdd from '@/components/WorkBench/WorkBenchSequenceWaggonWorkPackageAdd.component.vue';
import SWaggonRecommendation from '@/components/WorkBench/SWaggonRecommendation.component.vue';


import AIIcon from '@/components/WorkBench/AIIcon.component.vue';

export const WorkBenchSequenceMixin = {
  components: {
    draggable,

    StandardDialogFullScreen,
    StandardDialog,
    StandardFlexBox,
    StandardDataField,
    StandardHover,
    StandardBadge,
    StandardOverflowButton,

    StandardDeleteButton,
    StandardDeleteBtn,
    CommunitySuggestBtn,

    TUploadButton,
    TSearchField,

    TrainHead,
    TrainTail,
    Waggon,
    Workpackage,
    Activator,
    StatisticsTakt,
    StatisticsBeam,
    StatisticsBeamTaktSum,

    WorkBenchSequenceWaggon,
    WorkBenchSequenceWaggonAdd,
    WorkBenchSequenceWaggonTab,
    WorkBenchSequenceWaggonWorkPackage,
    WorkBenchSequenceWaggonWorkPackageAdd,
    SWaggonRecommendation,

    AIIcon,
  },
  data: () => ({
    update_key_add_hashtag: 0,
    ai_animation_recommendation: false,
    swaggon_rec_pos: 0,
    prefix_wp_seletion: ''
  }),
  computed: {
    ...mapGetters('WorkBench', [
      'getWBObject',
      'getWBObjects',
      'getWBObjectsFiltered',
      'getAISequenceWaggons',
      'getSequenceStatistics',
      'getSequenceWorkpackageColors',
      'getSequenceWorkpackageIcons',
      'isWBObjEmpty'
    ]),
    ...mapGetters('WorkBenchLocal', [
      'getWBLObject',
    ]),
    ...mapGetters('Auth', [
      'getUserId',
    ]),
    prefix(){
      switch (this.$route.params.template_type) {
        case 'custom':
          return '';
        case 'company':
          return 'b';
        case 'community':
          return 'c';
      }
      return '';
    },
    sequence(){
      if (this.$route.params.sequence_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {sequence: ''},
          ]
        });
      } else {
        return this.$store.state.WorkBench[`${this.prefix}sequences`][parseInt(this.$route.params.sequence_id)]
      }
    },
    waggon(){
      // this.$route.params.seq
      if (this.$route.params.sequence_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {sequence: ''},
            {swaggons: this.waggon_id},
          ]
        });
      } else if (this.$route.params.waggon_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {waggon: ''},
          ]
        });
      } else {
        return this.$store.state.WorkBench[`${this.prefix}swaggons`][parseInt(this.$route.params.waggon_id)]
      }
    },
    workbench_variables() {
      return this.getWBLObject({
        path: [
          {workbench_variables: ''}
        ]
      });
    },
    statistics() {
      return this.getSequenceStatistics({
        swaggons: this.sequence[`${this.prefix}swaggons`],
        local: this.create,
        prefix: this.prefix,
      });
    },
    statistic_settings() {
      return this.getWBLObject({
        path: [
          {sequence_editor_variables: 'statistic_settings'}
        ]
      });
    },
    // sequence() {
    //   if (!this.create) {
    //     return this.edit_sequence;
    //   } else {
    //     return this.new_work_package;
    //   }
    // },
  },
  methods: {
    ...mapActions('WorkBench', [
      'requestWBObject',
      'createWBObject',
      'updateWBObject',
      'updateWBObjectHashtags',
      'deleteWBObject',
      'changeWBObjectPosition',
      'changeWBObjectParent',
      'addLoadAll'
    ]),
    ...mapActions('WorkBenchLocal', [
      'createWBLObject',
      'updateWBLObject',
      'deleteWBLObject',
      'resetSequence'
    ]),
    addHashtag(evt) {
      let hashtags = JSON.parse(JSON.stringify(this.sequence.hashtags));
      hashtags.push({tag: evt.replace(/\s/g,'')});
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}sequences`]: this.sequence_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
      this.update_key_add_hashtag++;
    },
    removeHashtag(index) {
      let hashtags = JSON.parse(JSON.stringify(this.sequence.hashtags));
      hashtags.splice(index, 1);
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}sequences`]: this.sequence_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
    },
    getDraggableStyle(){
      return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
    },
    getNestedWorkPackageCreate(workpackage, copy_steps){
      return new Promise((resolve_complete) => {
      let work_package = JSON.parse(JSON.stringify(workpackage));
        [
          `worksteps`,
          `defectsteps`,
          `qualitysteps`,
          `handoversteps`,
          `logisticsteps`,
          `designsteps`,
          `machinesteps`,
          `workpackageimages`
        ].forEach(type => {
          if (this.create) {
            work_package[`w${type}`] = work_package[`s${type}`]?work_package[`s${type}`]:[];
          }
          else if (copy_steps) {
            work_package[`w${type}`] = this.getWBObjects({
              type: `s${type}`,
              ids: work_package[`s${type}`]
            });
          } else {
            work_package[`w${type}`] = [];
          }
          delete work_package[`s${type}`];
        });
        // delete work_package.created;
        // delete work_package.id;
        // delete work_package.owner;
        // delete work_package.updated;
        work_package.hashtags = [];
        // for (let i = 0; i < work_package.hashtags.length; i++) {
        //   work_package.hashtags.splice(i, 1, {tag: work_package.hashtags[i].tag});
        // }
        let calls = [];
        work_package.wworkpackageimages.forEach(image => {
          calls.push(
            new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", image.image);
            xhr.responseType = "blob";
            xhr.onload = function()
            {
               if (xhr.readyState === 4) {
                   if (xhr.status === 200) {
                       resolve(xhr.response);
                   }
                   else {
                       console.error(xhr.statusText);
                       reject(xhr.statusText);
                   }
               } else {
                   reject(xhr.statusText);
               }
              };
              xhr.setRequestHeader("mode", "no-cors");
              xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
              xhr.send();
            })
          );
        });
        Promise.all(calls)
        .then(resps => {
          for (let i = 0; i < resps.length; i++) {
            let file = new File([resps[i]], "image");
            work_package.wworkpackageimages[i].file = file;
            work_package.wworkpackageimages[i].local_url = URL.createObjectURL(file);
          }
          resolve_complete(work_package);
        });
      });
    },
    getSequenceForCreateCall() {
      let sequence = JSON.parse(JSON.stringify(this.sequence));
      sequence.swaggons.forEach(waggon => {
        waggon.sworkpackages.forEach(workpackage => {
          delete workpackage.sworkpackageimages;
        });
      });
      return sequence;
    },
    uploadSequenceWorkpackagesImageBulk(id) {
      const promises = [];
      let work_package_images = [];
      let waggons = this.getWBObject({
        type: 'sequences',
        id: id
      }).swaggons;
      this.sequence.swaggons.forEach((waggon, waggon_index) => {
        let workpackages = this.getWBObject({
          type: 'swaggons',
          id: waggons[waggon_index]
        }).sworkpackages;
        waggon.sworkpackages.forEach((workpackage, workpackage_index) => {
          workpackage.sworkpackageimages.forEach(workpackageimage => {
            work_package_images.push({
              sworkpackageimage: workpackageimage,
              waggon_id: waggons[waggon_index],
              work_package_id: workpackages[workpackage_index]
            });

          });
        });
      });
      work_package_images.forEach(work_package_image => {
        let image = new FormData();
        image.append("image", work_package_image.sworkpackageimage.file);
        promises.push(this.createWBObject({
          url: [
            {sequences: id},
            {swaggons: work_package_image.waggon_id},
            {sworkpackages: work_package_image.work_package_id},
            {sworkpackageimages: ''},
            {showWithEntitiesNormalized: ''}
          ],
          wb_object: image,
        }));
      });
      Promise.all(promises)
      .then((resp) => {
        const promises_two = [];
        for (let i = 0; i < resp.length; i++) {
          promises_two.push(this.updateWBObject({
            url: [
              {sequences: id},
              {swaggons: work_package_images[i].waggon_id},
              {sworkpackages: work_package_images[i].work_package_id},
              {sworkpackageimages: resp[i]}
            ],
            update: {
              comment: work_package_images[i].sworkpackageimage.comment
            },
          }));
        }
        Promise.all(promises_two)
        .then(() => {
          this.$router.push({
            name: 'WorkBenchSequences'
          });
        });
      });
    },
    getUnlikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.splice(likes_copy.findIndex(like => like.user.id === this.getUserId), 1);
      return likes_copy;
    },
    getLikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.push({
        user: {
          id: this.getUserId
        }
      });
      return likes_copy;
    }
  }
};
